import HrProfilePage from "./HrProfilePage";
export default HrProfilePage;